const PERMISSION_KEY= "core:promotion_coupon";
const PAGE_URL = {
    PROMOTION_COUPON_PAGE: "/admin/core/promotion-coupon"
}

export {PERMISSION_KEY, PAGE_URL}

